import { Variable } from "./variable";

export class VariableListComparison {
  before: Variable[];
  after: Variable[];

  public constructor(before: Variable[], after: Variable[]) {
    this.before = before;
    this.after = after;
  }
}